<template>
  <div class="relative">
    <div class="relative">
      <input
        v-model="searchFilter"
        type="text"
        autocomplete="off"
        class="search-input"
        :class="[borderClass]"
        :id="id"
        :name="id"
        placeholder="placeholder"
        @focus="showSuggestion"
        @blur="exit"
      />
      <label :for="id" class="label-ease input-type-ease bg-secondary">
        {{ inputPlaceHolder }}
      </label>
      <search-icon v-if="isFocused" class="prepend-icon" />
      <clear-icon v-if="isFocused" class="append-icon" @click="exit" />
    </div>
    <transition name="slide-suggestion">
      <div class="wrapper-suggestion" v-if="isFocused" >
        <p class="loading" v-if="isLoading">
          <base-loading spinnerColor="primary" />
        </p>
        <p
          class="suggestion-item"
          v-for="(filteredSearchItem, index) in filteredSearchItems"
          :key="index"
          @mousedown="selectedSuggest(filteredSearchItem)"
        >
          {{ filteredSearchItem.title }}
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import SearchIcon from '@/assets/icons/vue/search_normal.vue';
import ClearIcon from '@/assets/icons/vue/close_normal.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';

export default {
  name: 'BaseSearchInput',
  components: { BaseLoading, ClearIcon, SearchIcon },
  props: {
    itemsToSearch: {
      type: Array,
      default: null,
    },
    inputPlaceHolder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isAddable: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: String,
      default: 'sm',
    },
    default: {
      type: Object,
      default() {
        return {
          title: '',
        };
      },
    },
  },
  data() {
    return {
      isFocused: false,
      searchFilter: '',
      selected: {},
    };
  },
  mounted() {
    if (this.default.title) {
      this.searchFilter = this.default.title;
      this.selected = this.default;
    }
    this.$emit('searched', this.searchFilter ?? '');
  },
  watch: {
    // eslint-disable-next-line func-names
    searchFilter: debounce(function () {
      this.$emit('searched', this.searchFilter ?? '');
    }, 1000),
    default() {
      this.searchFilter = this.default.title ?? '';
      this.selected = this.default;
    },

  },
  computed: {
    borderClass() {
      return {
        rounded: this.radius === 'default',

        'rounded-sm': this.radius === 'sm',
      };
    },
    filteredSearchItems() {
      if (this.isAddable) {
        const addedItem = [];
        const isItemIncluded = this.itemsToSearch
        .some((el) => el.title.includes(this.searchFilter));
        if (!isItemIncluded) {
          addedItem.push({ title: this.searchFilter });
          return addedItem;
        }
      }
      return this.itemsToSearch;
    },
  },
  methods: {
    showSuggestion() {
      this.isFocused = true;
    },
    exit() {
      this.isFocused = false;
    },
    selectedSuggest(searchItem) {
      this.selected = searchItem;
      this.isFocused = false;
      this.searchFilter = this.selected.title;
      this.$emit('selectedItem', this.selected);
    },
  },
};
</script>
<style lang="css" scoped>
/* START TRANSITION */
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
.slide-suggestion-enter-active,
.slide-suggestion-leave-active {
  @apply transform transition duration-500 ease-custom;
}
.slide-suggestion-enter,
.slide-suggestion-leave-to {
  @apply -translate-y-1/2 scale-y-0  opacity-0;
}
.slide-suggestion-enter-to,
.slide-suggestion-leave {
  @apply translate-y-0 scale-y-100  opacity-100;
}
/* END TRANSITION */
input::placeholder {
  @apply font-semibold top-10 p-5 text-subtitle;
}
input[placeholder] {
  @apply focus:pl-26;
}
input[placeholder]:is(:lang(fa), :lang(ar)) {
  @apply focus:pr-26;
}
.wrapper-suggestion {
  @apply absolute bg-tertiary w-full border-t border-default z-10
  border-opacity-20 rounded-b p-2 h-128 overflow-y-scroll overflow-x-hidden;
}
.suggestion-item {
  @apply grid grid-flow-col auto-cols-max gap-4 place-items-center p-2 w-full
  rounded text-12 cursor-pointer transition duration-300 hover:bg-secondary;
}
.prepend-icon {
  @apply absolute top-1/3 left-10;
}
.append-icon {
  @apply absolute top-20 right-10 hover:cursor-pointer;
}
.search-input {
  @apply border border-default bg-secondary placeholder-subtitle
  font-medium block py-10 w-full h-50 px-2 text-12 text-title outline-none
  transition-all duration-500 focus:rounded-b-none focus:bg-secondary;
}
.loading {
  @apply text-center absolute top-1/2 right-1/2
  transform translate-x-1/2 -translate-y-1/2;
}
input::placeholder {
  @apply opacity-0;
}
.label-ease {
  @apply text-18 font-normal absolute px-5 py-5 mx-5
      transition-all ease-in-out duration-300;
  top: 0.3rem;
}
input:focus ~ label.input-type-ease,
input:not(:placeholder-shown) ~ label.input-type-ease {
  @apply -top-12 text-12;
}
</style>
